// extracted by mini-css-extract-plugin
export default {"topBorderOnError":"CashflowGrid_topBorderOnError__TVNQb"};